export const SortableColumns = [
  "app",
  "user",
  "actualRoleName",
  "createdAt",
  "lastSignedInAt",
] as const;

export const ColumnsToSortColumns = {
  app: "APP",
  user: "USER",
  actualRoleName: "APP_USER_ROLE",
  createdAt: "CREATED_AT",
  lastSignedInAt: "LAST_SIGNED_IN_AT",
} as const satisfies Record<(typeof SortableColumns)[number], string>;
